import NewAuditModal from './NewAuditModal.component';

export default NewAuditModal;
